import ApiStore from 'shared/stores/ApiStore';
import { computed } from 'mobx';
import { DIRECTION_CUSTOMS } from 'stores/QueryParamsStore'

export default class CodeStore extends ApiStore {

  @computed
  get onDate() {
    return this.rootStore.appStore.onDate;
  }

  constructor() {
    super(...arguments);

    if (this.constructor === CodeStore)
      throw new Error('Code Store must not be instantiated on its own');

    this.configure({
      domain: process.env.REACT_APP_API_DOMAIN,
      prefix: process.env.REACT_APP_API_PREFIX
    });
  }

  async fetchCodeData(code, type) {
    if (!type) throw new Error('Record type must be defined');

    const { appStore } = this.rootStore;

    appStore.isLoading = true;

    const id = code || appStore.code;
    const query = {
      'direction': appStore.direction || DIRECTION_CUSTOMS.COMMON,
      'clearanceCountry': appStore.clearanceCountry || 'RU',
      'originCountry': appStore.originCountry || 'ALL',
    };
    const url = this.buildUrl(type, { id, query });

    const codeData = await this.request(url);

    codeData.notes = null;
    codeData.comments = null;
    codeData.classification_comments = null;

    this.codes.clear();
    this.codes.set(codeData);

    appStore.isLoading = false;
  }

  // Примечания к ТН ВЕД ЕАЭС
  async fetchCodeDataNotes(code, type) {

    if (!type) throw new Error('Record type must be defined');
    if (!this.codes) throw new Error('codes must not be empty');

    if (this.codes.length !== 0) {

      const { appStore } = this.rootStore;

      appStore.isLoading = true;

      const id = code || appStore.code;
      let action = 'notes';
      const url_notes = this.buildUrl(type, { id, action });
      const notesData = await this.request(url_notes);

      if (notesData.notes !== undefined) {
        this.codes.items[0].notes = notesData.notes;
      }

      appStore.isLoading = false;
    }


  }

  // Пояснения к ТН ВЭД ЕАЭС (в ред. от 03.12.2019 г.)
  async fetchCodeDataComment(code, type) {

    if (!type) throw new Error('Record type must be defined');
    if (!this.codes) throw new Error('codes must not be empty');

    if (this.codes.length !== 0) {

      const { appStore } = this.rootStore;

      appStore.isLoading = true;

      const id = code || appStore.code;
      let action = 'comments';
      const url_comments = this.buildUrl(type, { id, action });
      const commentsData = await this.request(url_comments);

      if (commentsData.comments !== undefined) {
        this.codes.items[0].comments = commentsData.comments;
      }

      appStore.isLoading = false;
    }

  }

  //Разъяснения о классификации в соответствии с ТН ВЭД ЕАЭС отдельных товаров.
  async fetchCodeDataClassification_comments(code, type) {

    if (!type) throw new Error('Record type must be defined');
    if (!this.codes) throw new Error('codes must not be empty');

    if (this.codes.length !== 0) {

      const { appStore } = this.rootStore;

      appStore.isLoading = true;

      const id = code || appStore.code;
      let action = 'classification-comments';
      const url_classification_comments = this.buildUrl(type, { id, action });
      const classificationCommentsData = await this.request(url_classification_comments);

      if (classificationCommentsData.classification_comments !== undefined) {
        this.codes.items[0].classification_comments = classificationCommentsData.classification_comments;
      }

      appStore.isLoading = false;

    }

  }


  async reload(type) {
    if (!type) throw new Error('Record type must be defined');

    const { code } = this.rootStore.appStore;
    return await this.fetchCodeData(code, type);
  }

}



// WEBPACK FOOTER //
// ./src/stores/CodeStore.js